<app-header></app-header>

<!-- Title -->
<div class="section-lg bg-image parallax" style="background-image: url('assets/images/backgrounds/title-bg-1.jpg');">
  <div class="bg-dark-07">
    <div class="container">
      <div class="row g-4">
        <div class="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2 text-center">
          <h1 class="fw-black m-0 display-4">About Us</h1>
          <h2 class="fw-thin uppercase">CREATIVE DIGITAL AGENCY SINCE 2004</h2>
        </div>
      </div><!-- end row -->
    </div><!-- end container -->
  </div>
</div>
<!-- end Title -->

<!-- About section -->
<section class="section">
  <div class="container">
    <div class="row">
      <div class="col-md-6 heading-style-one box-title-three text-center offset-md-3">
        <h6 class="red-color uppercase">About Agency</h6>
        <h2 class="fw-black">We are an independent<br>strategic advertising agency.</h2>
        <div class="thin-border-purple thin-borders margin-auto mrt-40 mrb-40"></div>
        <p>If you want to have the most success when you are creating a homepage for your site, it is a good idea. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque aliquam vestibulum neque, id pellentesque purus dictum eget.</p>
      </div>
    </div>
  </div>
</section>
<!-- end About section -->

<!-- What We Do section -->
<div class="section pd-t-0 pd-b-0">
  <div class="container-fluid pd-0">
    <div class="row row-flex flex-center">
      <div class="col-md-6 col-sm-12">
        <div class="col-inner pd-t-70 pd-b-50 spacer border-top border-bottom">
          <div class="heading-style-one">
            <h6 class="red-color uppercase">What We Do</h6>
            <h2 class="display-6 fw-black">How we build awesome<br>products</h2>
          </div>
          <div class="mrt-30">
          <p>We are an Creative agency, based in New York. Vision Every company is
            performing best online. Mission Helping businesses to find the perfect
            and most succesful strategy, to be online.</p>
            <a class="lightbox-media-box button-circle button-circle-md button-circle-outline-dark button-circle-hover-slide mrt-30" (click)="openPopup()">
              <i class="bi bi-play-fill"></i>
              <i class="bi bi-play-fill"></i>
            </a>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-sm-12 bg-flex-cover" style="background-image: url(assets/images/about/about-img.jpg);"></div>
    </div>
  </div>
</div>
<!-- end What We Do section -->

<!-- Video Popup -->
<div class="video-popup" *ngIf="isOpen">
    <div class="popup-inner">
        <iframe width="560" height="315" src="https://www.youtube.com/embed/CygqGDPoZWQ?si=0GVlvXAPieQYM4RY" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        <button (click)="closePopup()" type="button" class="close-btn">
            <i class='bi bi-x'></i>
        </button>
    </div>
</div>

<!-- Testimonial section -->
<div class="section">
  <div class="container">
    <div class="row">
      <div class="col-12 col-lg-12 heading-style-one text-center">
        <h6 class="yellow-color uppercase">Testimonials</h6>
        <h2 class="display-6 fw-black">Our Clients Saying About Us</h2>
      </div>
    </div>
    <owl-carousel-o [options]="testimonialOptions" class="owl-btn-center-lr mrt-80 testimonial-two pd-0">
      <ng-template carouselSlide *ngFor="let tes of testimonials">
          <!-- Testimonial box -->
          <div class="testimonial-item">
              <div class="testimonial-content">
                  <div class="testimonial-content-in">
                      <div class="img">
                          <img class="img-responsive border-radius-100" src="assets/images/team/{{tes.image}}" alt="client-img">
                      </div>
                      <h5>{{tes.name}}</h5>
                      <h6>{{tes.position}}</h6>
                      <p>{{tes.desc}}</p>
                  </div>
              </div>
          </div>
      </ng-template>
  </owl-carousel-o>
    <div class="row">
      <div class="col-md-12">
        <div class="triangle-yellow-big d-sm-block" data-opacity="0.1"></div>
      </div>
    </div>
  </div><!-- end container -->
</div>
<!-- end Testimonial section -->

<!-- Blogs section -->
<div class="section-lg pd-b-0">
  <div class="row">
    <div class="col-md-12">
      <div class="square-light-green-big shapes d-sm-block" data-opacity="0.1"></div>
    </div>
  </div>
  <div class="container">
    <div class="row">
      <div class="col-12 col-lg-12 heading-style-one text-center">
        <h6 class="yellow-color uppercase">Our Blogs</h6>
        <h2 class="display-6 fw-black">Check What Happening Inside Score</h2>
      </div>
    </div>
    <div class="row align-items-center mrt-50">
        <div class="col-md-4" *ngFor="let post of posts">
            <div class="post">
                <div class="post-img">
                    <img class="img-responsive" [src]="post.image" [alt]="post.title">
                </div>
                <div class="post-info">
                    <h3>
                        <a routerLink="/blog-grid">{{ post.title }}</a>
                    </h3>
                    <h6 [ngClass]="post.color">
                        {{ post.category }}
                    </h6>
                    <p>{{ post.time }}</p>
                    <a class="readmore" routerLink="/blog-grid">
                        <span>
                            Read More
                            <i class="eicon bi bi-arrow-right-short"></i>
                        </span>
                    </a>
                </div>
            </div>
        </div>
    </div>
  </div><!-- end container -->
</div>
<!-- end Blogs section -->

<footer class="footer footer-three">
  <div class="footer-main">
    <div class="container">
      <div class="row">
        <!-- ABOUT -->
        <div class="col-sm-6 col-md-3">
          <div class="widget widget-links">
            <h5 class="widget-title">About Us</h5>
            <div class="footer-about">
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                In at purus varius odio tempus cursus. vitae, commodo dui.
              </p>
              <ul class="social-media">
                <li *ngFor="let social of socialLinks">
                  <a [href]="social.url" class="bi" [ngClass]="social.icon"></a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!-- QUICK LINKS -->
        <div class="col-sm-6 col-md-2">
          <div class="widget widget-links">
            <h5 class="widget-title">Quick Links</h5>
            <ul>
              <li *ngFor="let link of quickLinks">
                <a [href]="link.url">{{link.name}}</a>
              </li>
            </ul>
          </div>
        </div>
        <!-- RECENT POSTS -->
        <div class="col-sm-6 col-md-4">
          <div class="widget widget-links">
            <h5 class="widget-title">Recent Post</h5>
            <div class="row post-sm-content" *ngFor="let post of recentPosts; let i=index" [class.mrt-20]="i > 0">
              <div class="col-md-3 col-sm-3 col-xs-3">
                <img class="img-overlay border-radius-100" [src]="post.image" alt="post">
              </div>
              <div class="col-md-9 col-sm-9 col-xs-9">
                <h6>{{post.title}}</h6>
                <p>{{post.desc}}</p>
              </div>
            </div>
          </div>
        </div>
        <!-- CONTACT -->
        <div class="col-sm-6 col-md-3">
          <div class="widget widget-text">
            <h5 class="widget-title">Contact Us</h5>
            <ul class="footer-contact">
              <li>
                <i class="bi bi-pin-fill"></i>
                <p>Schönhauser Allee 167c 10435 Berlin Germany</p>
              </li>
              <li>
                <i class="bi bi-envelope"></i>
                <p>
                  <a href="mailto:yoursite@gmail.com">
                    yoursite&#64;gmail.com
                  </a>
                </p>
              </li>
              <li>
                <i class="bi bi-phone-fill"></i>
                <p>+49 30 47373795</p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>


  <!-- COPYRIGHT -->
  <div class="footer-copyright">

    <div class="container">

      <div class="row d-flex justify-content-center">
        <div class="col-md-2">

          <div class="logo-footer">
            <a routerLink="/">
              <img class="img-responsive" src="assets/images/logo-footer.png" alt="footer-logo">
            </a>
          </div>

        </div>
      </div>


      <div class="row">
        <div class="col-md-12">

          <div class="copy-right"> © Copyright 2026 Chaos. Designed By <a href="https://themeforest.net/user/designsninja/portfolio" target="_blank">
              DesignsNinja
            </a>
          </div>

        </div>
      </div>

    </div>

  </div>

</footer>



